import type { MaybeRefOrGetter } from 'vue';

/**
 * YouTube 動画タイトルをクライアント側で遅延取得する（facade の hover 表示用）。
 *
 * - `server/api/youtubeOembed` プロキシ経由で取得（`youtube.com/oembed` は CORS 不可のため）。
 * - `onMounted`（クライアントのみ）で取得するので SSR には乗らない。hover ラベル用途のため許容。
 * - 取得は素の `fetch`（相対 URL）。Nuxt 実行時は同一オリジンの Nitro ルートに解決され、
 *   テストでは MSW で傍受できる。`$fetch`（Nuxt グローバル）はテスト環境に無いため使わない。
 * - `videoId` が空（undefined）なら取得しない（上位でタイトルを静的指定したい場合に skip できる）。
 */
export const useYouTubeTitle = (videoId: MaybeRefOrGetter<string | undefined>) => {
  const title = ref<string>();

  onMounted(async () => {
    const id = toValue(videoId);
    if (!id) return;
    try {
      const res = await fetch(`/api/youtubeOembed?videoId=${encodeURIComponent(id)}`);
      if (!res.ok) return;
      const data = (await res.json()) as { title?: string | null };
      title.value = data.title || undefined;
    } catch {
      // 取得失敗時はタイトル非表示（facade は通常どおり機能）
    }
  });

  return { title };
};
